import './set-public-path'
import Vue from 'vue'
import singleSpaVue from 'single-spa-vue'
import { i18n } from '@leapsight/portal'
import router from './router'
import vuetify from './plugins/vuetify'
// Local vuex store
import store from './store/index'
import App from './App.vue'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render: (h: any) => h(App),
    router,
    store,
    vuetify,
    i18n
  }
})

export const bootstrap = vueLifecycles.bootstrap
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount
